import {GenexLMSModel} from "@/models/lms/GenexLMSModel";
import Note from '@/models/lms/Note'
import User from '@/models/lms/User'
import BoardUser from '@/models/lms/BoardUser'
import GenexHelperMixins from "@/mixins/GenexHelperMixins";


export default class Board extends GenexLMSModel {
    static entity = 'boards'

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            description: this.attr(''),
            group_id: this.attr(null),
            owner_id: this.attr(''),
            owner: this.belongsTo(User, 'owner_id'),
            is_public: this.attr(false),
            notes: this.hasMany(Note, 'board_id'),
            users: this.belongsToMany(User, BoardUser, 'board_id', 'user_id')
        }
    }


    static createBoard(board) {
        return this.api().post(`/boards`, board, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            save: false
        })
    }
    static updateBoard(board) {
        return this.api().post(`/boards/${board.id}`, board, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            save: false,
        })
    }


    static showBoardUsers(board_id) {
        return this.api().get(`/boards/${board_id}/users`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            dataTransformer: (response) => {
                let storageArray = []
                response.data.data.forEach(element => {
                    let target = element
                    Object.assign(target, target.attributes)
                    element.id = parseInt(element.id)
                    storageArray.push(target)
                })

                Board.insertOrUpdate({
                    data: {
                        id: board_id,
                        users: storageArray
                    }
                })
            }
        })
    }

    static addBoardUser(board_id, user_id) {
        return this.api().post(`/boards/${board_id}/add-user`, {
            user_id: user_id
        }, {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            save: false
        })
    }

    static removeBoardUser(board_id, user_id) {
        return this.api().post(`/boards/${board_id}/remove-user`, {
            user_id: user_id
        }, {
            ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            save: false
        })
    }

    static deleteBoard(board_id) {
        return this.api().delete(`/boards/${board_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            save: false
        })
    }
    static showBoard(board_id, relationships = ['owner']) {
        return this.api().get(`/boards/${board_id}`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            params: {
                ...(relationships ? {
                    with: relationships
                } : {}),
            },
            dataTransformer: (response) => {

                let element = response.data.data

                let target = element
                Object.assign(target, target.attributes)
                Object.assign(target.owner, target.owner.attributes)

                return target
            }
        })
    }


    static listBoards(relationships = null, search = null, user_id = null, page = 1, limit = 999) {
        return this.api().get(`/boards`, {
                ...GenexHelperMixins.methods.DefaultLMSHeadersAndBaseUrl(),
            params: {
                page: page,
                limit: limit,
                ...(relationships ? {
                    with: relationships
                } : {}),
                ...(user_id ? {
                    user_id: user_id
                } : {}),
                ...(search ? {
                    search: search
                } : {})
            },
            dataTransformer: (response) => {
                let storageArray = []
                response.data.data.forEach(element => {
                    let target = element
                    Object.assign(target, target.attributes)
                    Object.assign(target.owner, target.owner.attributes)
                    element.owner.id = parseInt(element.owner.id)
                    storageArray.push(target)
                });
                Board.insert({
                    data: storageArray
                })

            }
        })
    }
}
